import { makeStyles, Theme } from '@material-ui/core'

import { COLORS } from '../../../../../../../services/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  treeNodeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    backgroundColor: COLORS.WARM_GRAY,
    marginBottom: '5px',
    minHeight: '70px',
    height: 'auto',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  singleSelectionNode: {
    height: '51px',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginRight: theme.spacing(2),
    paddingLeft: '20px',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },
  fillX: {
    width: '100%',
  },
  emailList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    marginTop: theme.spacing(0.25),
  },
  nodesWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    minHeight: '200px',
    display: 'block',
  },
  singleSelectionTreeLabel: {
    fontSize: '14px',
  },
  singleSelectionTreeLabelSelectable: {
    fontSize: '14px',
    marginLeft: '22px',
  },
  selectAllLabel: {
    fontSize: '12px',
    lineHeight: '14px',
  },
  treeCheckbox: {
    '& svg': {
      width: '14px',
      height: '14px',
    },
  },
  singleSelectionTreeCheckbox: {
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
  arrowColumn: {
    minHeight: '52px',
    borderLeft: `2px solid ${COLORS.BLUE_GRAY_SECONDARY}`,
    '& button': {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      color: COLORS.BLACK,
    },
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    flexShrink: 0,
    '& > div': {
      display: 'flex',
      minWidth: '45px',
      alignItems: 'center',
      justifyContent: 'center',
      borderLeft: `1px solid ${COLORS.BLUE_GRAY_SECONDARY}`,
      minHeight: '52px',
    },
  },
  actionPartWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: 0,
    paddingTop: theme.spacing(0.25),
    '& > button': {
      marginRight: '10px',
    },
  },
  '@media (min-width: 1224px)': {
    treeCheckbox: {
      paddingLeft: '24px',
      paddingRight: '10px',
      '& svg': {
        width: '20px',
        height: '20px',
      },
    },
    selectAllLabel: {
      fontFamily: 'Cerebri Sans Pro Regular',
      fontSize: 'initial',
    },
    arrowColumn: {
      minWidth: '25px',
      height: '61px',
      borderLeft: 'none',
      '& button': {
        color: COLORS.BLACK,
      },
    },
    singleSelectionTreeCheckbox: {
      marginLeft: '10px',
      '& svg': {
        width: '20px',
        height: '20px',
      },
    },
    singleSelectionTreeLabel: {
      fontFamily: 'Cerebri Sans Pro Medium',
      fontSize: '16px',
    },
    singleSelectionTreeLabelSelectable: {
      fontFamily: 'Cerebri Sans Pro Medium',
      fontSize: '16px',
    },
  },
}))
